import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

import { IEPRequest } from '@innersight-os/shared/firestore-interfaces';
import { doc, DocumentReference } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';

@Injectable({
  providedIn: 'root'
})
export class IEPRequestsService {
  getIEPRequest = (operationId: string): Observable<IEPRequest> =>
    docData<IEPRequest>(doc(this.db, `operations/${operationId}/iep/request`) as DocumentReference<IEPRequest>)

  constructor(
    private db: Firestore,
  ) {}
}
